import React, { useContext } from 'react';
import { HistoryPickupsContext } from 'contexts/HistoryPickupsContext';
import { Loading } from 'components/Shared/Loading';
import { FileArchive, AlertCircle, CheckCircle2 } from 'lucide-react';

export const HistoryPickupsList: React.FC = () => {
  const { historyPickups, loading, loadingDownloadId, handleDownloadZip } = useContext(HistoryPickupsContext);

  const formatAbsoluteDate = (dateString: string | null) => {
    if (!dateString) return "---";
    return dateString.split('T')[0].split('-').reverse().join('/');
  };

  if (loading) {
    return <div className="flex justify-center p-10"><Loading /></div>;
  }

  if (!historyPickups.length) {
    return (
      <div className="flex justify-center items-center py-10 text-gray-500">
        Nenhum registro de histórico encontrado.
      </div>
    );
  }

  return (
    <div className="overflow-x-auto w-full">
      <table className="w-full text-left text-sm text-gray-600 border-collapse">
        <thead className="text-gray-700 font-semibold border-b">
          <tr>
            <th className="px-4 py-3 whitespace-nowrap">ID</th>
            <th className="px-4 py-3 whitespace-nowrap">RQPS</th>
            <th className="px-4 py-3 whitespace-nowrap">DATA SOLIC.</th>
            <th className="px-4 py-3 whitespace-nowrap">CLIENTE</th>
            <th className="px-4 py-3 whitespace-nowrap">TRANSPORTADORA</th>
            <th className="px-4 py-3 whitespace-nowrap">NF</th>
            <th className="px-4 py-3 whitespace-nowrap">STATUS</th>
            <th className="px-4 py-3 whitespace-nowrap text-center">ANEXOS</th>
          </tr>
        </thead>
        
        <tbody className="divide-y divide-gray-200 bg-white">
          {historyPickups.map((collect) => (
            <tr key={collect.id} className="hover:bg-gray-50 transition-colors">
              <td className="px-4 py-3 font-semibold text-gray-800">
                #{collect.id}
              </td>

              <td className="px-4 py-3 text-gray-600">
                {collect.rqps || "---"}
              </td>
              
              <td className="px-4 py-3 whitespace-nowrap text-gray-500">
                {formatAbsoluteDate(collect.requestDate)}
              </td>
              
              <td className="px-4 py-3">
                <div className="max-w-[200px] truncate" title={collect.clientName || ''}>
                  {collect.clientName || "---"}
                </div>
              </td>

              <td className="px-4 py-3">
                <div className="max-w-[150px] truncate" title={collect.carrier || ''}>
                  {collect.carrier || "---"}
                </div>
              </td>
              
              <td className="px-4 py-3 font-medium text-gray-700">
                {collect.invoiceNumber || "---"}
              </td>
              
              <td className="px-4 py-3">
                {collect.isCanceled ? (
                  <span className="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">
                    <AlertCircle size={12} />
                    Cancelada
                  </span>
                ) : (
                  <span className="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                    <CheckCircle2 size={12} />
                    Concluída
                  </span>
                )}
              </td>
              
              <td className="px-4 py-3 text-center">
                {collect.attachments && collect.attachments.length > 0 ? (
                  <button
                    onClick={() => handleDownloadZip(collect.id)}
                    disabled={loadingDownloadId === collect.id}
                    className="inline-flex items-center justify-center gap-2 px-3 py-1.5 bg-[#EE7C2C] text-white text-sm font-medium rounded-md hover:bg-[#ED8C49] disabled:opacity-50 disabled:cursor-not-allowed transition-all shadow-sm"
                    title="Baixar arquivos zipados"
                  >
                    {loadingDownloadId === collect.id ? (
                      <Loading />
                    ) : (
                      <>
                        <FileArchive size={16} />
                        <span>Baixar ({collect.attachments.length})</span>
                      </>
                    )}
                  </button>
                ) : (
                  <span className="text-gray-400 text-xs italic">Sem anexos</span>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};